import styled from '@emotion/styled';
import { rem } from '@utils';

const DescriptionList = styled.dl();

const DescriptionTitle = styled.dt`
  align-items: center;
  column-gap: ${rem(8)};
  display: flex;
  font-size: ${rem(14)};
  font-weight: 600;
  line-height: ${rem(16)};
  height: ${rem(24)};
  margin-bottom: ${rem(4)};
  padding-left: ${rem(8)};
`;

const DescriptionDetails = styled.dd`
  font-size: ${rem(14)};

  &:not(:last-of-type) {
    margin-bottom: ${rem(16)};
  }
`;

const FooterButton = styled.span`
  display: block;
  margin-left: auto;

  .button {
    font-weight: 600;
  }
`;

const CloseButton = styled.div`
  border-radius: 4px;
  cursor: pointer;
  height: ${rem(32)};
  transition: 200ms;
  
  &:active {
    background: ${({ theme }) => theme.palette.primary.dark};
    
    * {
      fill: ${({ theme }) => theme.palette.common.white};
    }
  }
`;

export default {
  DescriptionList,
  DescriptionTitle,
  DescriptionDetails,
  FooterButton,
  CloseButton
};
